import React, { FC } from "react";
import Video from "apps/website/components/base/Video/Video";
import TrustPilotStars from "apps/website/components/misc/TrustPilotStars";
import { TrustpilotRating } from "apps/website/api/Trustpilot";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextControl from "apps/website/components/base/Text/TextControl/TextControl";
import cx from "apps/website/utils/misc/cx";

export interface ITastyMonialsCarouselItem {
  videoSrc: string;
  quote: string;
  author: string;
  poster: string;
  rating: TrustpilotRating;
}

const TastyMonialsCarouselItem: FC<ITastyMonialsCarouselItem> = ({ videoSrc, quote, author, poster, rating }) => (
  <div className="testimonial-item border border-gray-200 rounded-lg  h-[375px] relative overflow-hidden">
    <div className="absolute inset-0">
      <Video
        video={videoSrc}
        poster={poster}
        controls={false}
        canPause={false}
        cover={true}
        muted={true}
        type="video/webm"
      />
    </div>
    <div className="absolute w-full h-full top-0 left-0 bg-gradient-to-t from-black/60 from-0% via-black/0 via-80% to-transparent z-10" />
    <div className={cx("text-content absolute bottom-0 left-0 px-2 pb-6 w-full flex flex-col gap-2 z-20")}>
      <TextSubtitle size={2} className="text-white" whitespace="balance">{ quote }</TextSubtitle>
      <TextControl size={2} className="text-white capitalize" whitespace="balance">{ author }</TextControl>
      <div className="w-20 h-4">
        <TrustPilotStars rating={rating} />
      </div>
    </div>
  </div>
);

export default TastyMonialsCarouselItem;
